<li *ngIf="this.hasMultiple && !isSupporter">
  <a class="nav-link" (click)="openVerticallyCentered(contentt)">
    <app-svg source="icons/feather/refresh-cw" height="18"></app-svg>
    <span class="ps-2" i18n="@@SwitchAccountButton">Konto wechseln</span>
  </a>

  <ng-template #contentt let-modal>
    <div class="modal-header">
      <h4 class="modal-title" i18n="@@SwitchAccountHeader">Kontenwechsel</h4>
      <button type="button" id="change_account" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    
    <div class="modal-body">
      <div class="container">
        <div class="row">
          <div class="col pt-3 text-center">
            <app-svg source="icons/feather/refresh-cw" height="68"></app-svg>
          </div>
          <div class="col">
            <h6 i18n="@@AccountsHeader">Konten:</h6>
            <ng-container *ngFor="let item of this.customers">
              <button ngbDropdownItem (click)="$event.stopPropagation(); changeCustomer(item)" id="current_user" class="border my-2 btn btn-outline-light">{{item.name}} <span *ngIf="this.user.selectedCustomerId == item.id" class="badge badge-success ms-2" i18n="@@CurrentlyLogged">derzeit angemeldet</span></button>
            </ng-container>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="text-muted" i18n="@@AccountSwitchMessage">Wechseln Sie bequem von einem Benutzerkonto zum anderen. Ohne sich neu anmelden zu müssen. </p>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" id="cancel_account_change" class="btn btn-danger" (click)="modal.close('Close click')" i18n="@@CancelAccountSwitchButton">Wechseln abbrechen</button>
    </div>
  </ng-template>
</li>
